import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import { makeTree } from 'utils/tree'

import { Button } from 'components'

import './pageIndex.scss'

const findNode = (id, currentNode) => {
	let i
	let currentChild
	let result

	if (id === currentNode.id) return currentNode
	if (!currentNode.children) return false

	for (i = 0; i < currentNode.children.length; i += 1) {
		currentChild = currentNode.children[i]

		result = findNode(id, currentChild)

		if (result !== false) return result
	}

	return false
}

const renderChildren = children => {
	if (!children || !children.length) return null

	return (
		<ol>
			{children.map(child => (
				<li key={child.id}>
					<Button
						to={child.id}
						text={child.title}
						layout="underlined-text"
					/>
					{renderChildren(child.children)}
				</li>
			))}
		</ol>
	)
}

class PageIndex extends PureComponent {
	onRemove = () => {
		const { editor, node } = this.props

		editor.removeNodeByKey(node.key)
	}

	render() {
		const { articles, t, id, attributes } = this.props
		const sitemap = makeTree(articles, t)

		if (!sitemap) return <></>

		let filtered

		sitemap.forEach(element => {
			const f = findNode(id, element)

			if (f) {
				filtered = findNode(id, element)
			}
		})

		return (
			<div
				{...attributes}
				className={`c-page-index ${attributes.className}`}
			>
				{filtered && filtered.children ? (
					filtered.children && renderChildren(filtered.children)
				) : (
					<b>No subpages available.</b>
				)}
			</div>
		)
	}
}

const mapStateToProps = state => ({
	id: state.articles.article.id,
	articles: state.articles.list,
})

export default connect(mapStateToProps, null)(translate()(PageIndex))
